import { Component, Input } from "@angular/core";
import { Chart } from "chart.js";
import { COLOR_BSC, GraficaBsc } from "../graficas/grafica-bsc";
import { pct } from "../bsc-formato";

@Component({
  selector: "app-avance-indicador-bsc",
  standalone: true,
  template: '<div class="avance"><canvas #lienzo role="img" [attr.aria-label]="descripcion"></canvas></div>',
  styles: [":host { display: block; } .avance { position: relative; width: 220px; height: 100px; }"],
})
export class AvanceIndicadorBscComponent extends GraficaBsc {
  @Input() real: (number | null)[] = [];
  @Input() nombre = "Indicador";

  get descripcion(): string {
    const trimestres = this.real.map((v, i) => `Q${i + 1}: ${pct(v, "sin dato")}`).join("; ");
    return `${this.nombre}. ${trimestres}`;
  }

  protected arma(lienzo: HTMLCanvasElement): Chart {
    return new Chart(lienzo, {
      type: "line",
      data: { labels: ["Q1", "Q2", "Q3", "Q4"], datasets: [{
        label: "Alcance acumulado", data: this.real, borderColor: this.color(COLOR_BSC.real),
        backgroundColor: this.color(COLOR_BSC.real), borderWidth: 2, pointRadius: 3, spanGaps: false,
      }] },
      options: {
        responsive: true, maintainAspectRatio: false, animation: false,
        scales: {
          x: { grid: { display: false }, ticks: { color: this.color(COLOR_BSC.suave) } },
          y: { beginAtZero: true, ticks: { color: this.color(COLOR_BSC.suave), maxTicksLimit: 3,
            callback: (v) => pct(Number(v)) }, grid: { color: this.color(COLOR_BSC.rejilla) } },
        },
        plugins: { legend: { display: false }, tooltip: { callbacks: {
          label: (c) => pct(c.raw as number | null),
        } } },
      },
    });
  }
}
